"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theming = require("../../theming");

var _themeContants = require("../../constants/themeContants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var tProps = {
  button: {
    name: "Button",
    description: "Button styles",
    type: _themeContants.themePropTypes.style
  }
};

var ButtonComp = _styledComponents["default"].button.withConfig({
  displayName: "Button__ButtonComp",
  componentId: "n2qp4u-0"
})(["background-color:", ";color:", ";border-width:0;border-radius:", ";padding:", " ", ";cursor:pointer;min-height:", ";text-decoration:none;text-align:center;display:inline-block;font-size:", ";font-family:", ";line-height:32px;font-weight:", ";white-space:nowrap;justify-content:center;align-items:center;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;transition:background 0.2s ease;&:hover,&:focus{outline:none;background-color:", ";color:", ";}", ";"], _theming.color.primary, _theming.color.white, _theming.borderRadius, _theming.spacing.tiny, _theming.spacing.medium, _theming.targetSize.normal, _theming.font.base, _theming.fontFamily.body, _theming.fontWeight.bold, _theming.color.primary, _theming.color.white, (0, _theming.applyVariants)(tProps.button.name));
/**
 * Button component. Use to click stuff
 */


var Button = function Button(props) {
  return _react["default"].createElement(ButtonComp, props);
};

var defaultProps = {
  children: "button",
  onClick: null
};
var propTypes = {
  /**
   * The children of the lamb
   */
  children: _themeContants.commonPropTypes.children.isRequired,

  /**
   * Click callback. Why else have a button?
   * @export
   */
  onClick: _propTypes["default"].func
};
Button.defaultProps = defaultProps;
Button.propTypes = propTypes;
Button.themeProps = tProps;
var _default = Button;
exports["default"] = _default;